/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // buy 1 or buy 6 button
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.quick-add__radio').forEach(radio => {
      radio.addEventListener('change', function () {
        const form = radio.closest('form');
        const hiddenSubmitButton = form.querySelector('.quick-add__button.hidden');
        
        // Set the correct quantity in the form
        const quantityInput = form.querySelector('input[name="quantity"]');
        quantityInput.value = radio.value;
  
        // Trigger the hidden submit button click
        hiddenSubmitButton.click();
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pdp_buy_6').forEach(button => {
      button.addEventListener('click', function () {
        const form = button.closest('form');
        const quantityInput = form.querySelector('input[name="quantity"]');
        const addToCartButton = form.querySelector('button[data-add-to-cart]');
  
        if (quantityInput && addToCartButton) {
          quantityInput.value = 6; // Set quantity to 6
          addToCartButton.click(); // Trigger Add to Cart button
        }
      });
    });
  });
  
  document.addEventListener('DOMContentLoaded', function () {
  var targetSection = document.querySelector("#altruist-section");

  if (targetSection) {
    var selectorWrapper = document.createElement("div");
    selectorWrapper.className = "altruist-charity-selector";
    selectorWrapper.innerHTML = `
      <select id="charity_select" class="charity-dropdown contactFormSelect field">
        <option value="" disabled selected>Choose a Charity</option>
        <option value="Reclink Australia">Reclink Australia</option>
        <option value="Inala Disability Services">Inala Disability Services</option>
        <option value="Help Enterprises">Help Enterprises</option>
        <option value="Lutheran Youth Queensland">Lutheran Youth Queensland</option>
      </select>
    `;

    targetSection.appendChild(selectorWrapper);
  }

  var select = document.getElementById('charity_select');
  var charityInputs = document.querySelectorAll('.altruist_charity');
  var charityTagInputs = document.querySelectorAll('.charity_tag');

  function updateCharityValues(selectedValue) {
    // Update hidden inputs
    charityInputs.forEach(function (input) {
      input.value = selectedValue;
    });

    charityTagInputs.forEach(function (input) {
      input.value = selectedValue ? 'Altruist, ' + selectedValue : 'Altruist';
    });
  }

  if (select) {
    // 1. Event listener for manual selection
    select.addEventListener('change', function () {
      updateCharityValues(select.value);
    });

    // 2. URL param auto-selection
    var params = new URLSearchParams(window.location.search);
    var charityFromURL = params.get('charity');

    if (charityFromURL) {
      // Convert dashes or URL-encoded names to spaces if needed
      var decodedCharity = decodeURIComponent(charityFromURL.replace(/\+/g, ' ').replace(/-/g, ' '));

      // Check if the option exists in the dropdown
      var optionExists = Array.from(select.options).some(opt => opt.value === decodedCharity);

      if (optionExists) {
        select.value = decodedCharity;
        updateCharityValues(decodedCharity);
      }
    }
  }
});


})();
